const AUTH_TOKEN_KEY = "token";
const AUTH_EXPIRES_KEY = "token_expires_at";
const USER_KEY = "user";

const FOURNISSEUR_TOKEN_KEY = "fournisseur_token";
const FOURNISSEUR_EXPIRES_KEY = "fournisseur_token_expires_at";
const FOURNISSEUR_ID_KEY = "fournisseur_id";
const FOURNISSEUR_MUST_CHANGE_KEY = "fournisseur_must_change_password";

const DEFAULT_SESSION_MS = 8 * 60 * 60 * 1000;
const SESSION_EXPIRED_KEY = "session_expired_message";

const resolveExpiry = (payload = {}) => {
  if (payload.expires_at) {
    const parsed = Date.parse(payload.expires_at);
    if (!Number.isNaN(parsed)) return parsed;
  }

  if (payload.expires_in) {
    return Date.now() + Number(payload.expires_in) * 1000;
  }

  return Date.now() + DEFAULT_SESSION_MS;
};

const isStoredTokenValid = (tokenKey, expiresKey) => {
  const token = localStorage.getItem(tokenKey);
  const expiresAt = Number(localStorage.getItem(expiresKey));
  return Boolean(token && expiresAt && expiresAt > Date.now());
};

export const clearAuthSession = () => {
  localStorage.removeItem(AUTH_TOKEN_KEY);
  localStorage.removeItem(AUTH_EXPIRES_KEY);
  localStorage.removeItem(USER_KEY);
};

export const clearFournisseurSession = () => {
  localStorage.removeItem(FOURNISSEUR_TOKEN_KEY);
  localStorage.removeItem(FOURNISSEUR_EXPIRES_KEY);
  localStorage.removeItem(FOURNISSEUR_ID_KEY);
  localStorage.removeItem(FOURNISSEUR_MUST_CHANGE_KEY);
};

export const markSessionExpired = (message = "Votre session a expire. Veuillez vous reconnecter.") => {
  localStorage.setItem(SESSION_EXPIRED_KEY, message);
};

export const consumeSessionExpiredMessage = () => {
  const message = localStorage.getItem(SESSION_EXPIRED_KEY);
  localStorage.removeItem(SESSION_EXPIRED_KEY);
  return message;
};

export const saveAuthSession = ({ token, user, expires_at, expires_in }) => {
  localStorage.setItem(AUTH_TOKEN_KEY, token);
  localStorage.setItem(AUTH_EXPIRES_KEY, String(resolveExpiry({ expires_at, expires_in })));
  localStorage.setItem(USER_KEY, JSON.stringify(user || {}));
};

export const saveFournisseurSession = ({
  token,
  fournisseur_id,
  must_change_password,
  expires_at,
  expires_in,
}) => {
  localStorage.setItem(FOURNISSEUR_TOKEN_KEY, token);
  localStorage.setItem(FOURNISSEUR_EXPIRES_KEY, String(resolveExpiry({ expires_at, expires_in })));
  localStorage.setItem(FOURNISSEUR_ID_KEY, String(fournisseur_id));
  localStorage.setItem(FOURNISSEUR_MUST_CHANGE_KEY, String(must_change_password));
};

export const isAuthenticated = () => {
  const valid = isStoredTokenValid(AUTH_TOKEN_KEY, AUTH_EXPIRES_KEY);
  if (!valid && localStorage.getItem(AUTH_TOKEN_KEY)) {
    markSessionExpired();
    clearAuthSession();
  }
  return valid;
};

export const isFournisseurAuthenticated = () => {
  const valid = isStoredTokenValid(FOURNISSEUR_TOKEN_KEY, FOURNISSEUR_EXPIRES_KEY);
  if (!valid && localStorage.getItem(FOURNISSEUR_TOKEN_KEY)) {
    markSessionExpired();
    clearFournisseurSession();
  }
  return valid;
};

export const isAdminAuthenticated = isAuthenticated;

export const getAuthToken = () => (isAuthenticated() ? localStorage.getItem(AUTH_TOKEN_KEY) : null);

export const getFournisseurToken = () =>
  isFournisseurAuthenticated() ? localStorage.getItem(FOURNISSEUR_TOKEN_KEY) : null;
